import ClipLoader from "react-spinners/ClipLoader";

export default function SubmitField({label,loader}) {
  // let [loading, setLoading] = useState(true);

  // const override = {
  //   display: "white",
  //   margin: "0 auto",
  //   borderColor: "white",
  // };

  return (
    <button
      type="submit"
      className="bg-primary hover:bg-info/90 text-white block py-4 px-4 text-center w-full font-imprima "
      disabled={loader}
    >
      {label}
      <ClipLoader
        color={"#ffffff"}
        loading={loader}
        // cssOverride={override}
        size={15}
        className="relative top-1 left-2"
        aria-label="Loading "
        data-testid="loader"
      />
    </button>
  );
}
